import React, { useMemo, useState } from "react";
import { FiPlusCircle, FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";


import { openS3Document } from "../lib/documents";

function FinancialReports() {
  const { t } = useTranslation();

  const [openIndex, setOpenIndex] = useState(null);

  const reportGroups = useMemo(
    () => [
      {
        title: t("main.financialReport.groups.financialReport2026"),
        files: [
          {
            name: t("main.financialReport.documents.interim2026Unaudited"),
            key: "financial_reports/2026/Rigsave_Interim_FS_2026_unaudited_unconsolidated.pdf",
          },
        ],
      },
      {
        title: t(
          "main.financialReport.groups.financialReport2025",
          "Financial Report 2025"
        ),
        files: [
          {
            name: t("main.financialReport.documents.separate2025Ifrs"),
            key: "financial_reports/2025/rigsavespa_separate_financial_statement_2025.pdf",
          },
          {
            name: t("main.financialReport.documents.financialStatement2025"),
            key: "financial_reports/2025/rigsavespa_bilancio_31dic2025_revised.pdf",
          },
          {
            name: t("main.financialReport.documents.halfYear2025En"),
            key: "financial_reports/2025/rigsavespa_unconsolidated_FS_2025_Interim.pdf",
          },
        ],
      },
      {
        title: t("main.financialReport.groups.financialReport2024"),
        files: [
          {
            name: t("main.financialReport.documents.annual2024EnIfrs"),
            key: "financial_reports/2024/annualAuditedUnconsolidatedFinancialStatementIFRS2024.pdf",
          },
          {
            name: t("main.financialReport.documents.annual2024ItGaap"),
            key: "financial_reports/2024/2024_IT_annual_audited_unconsolidated_financial_statement_ITA_GAAP.pdf",
          },
          {
            name: t(
              "main.financialReport.documents.halfYear2024EnIfrsConsolidated"
            ),
            key: "financial_reports/2024/2024_EN_IFRS_consolidated_half_year_report.pdf",
          },
        ],
      },
      {
        title: t("main.financialReport.groups.financialReport2023"),
        files: [
          {
            name: t("main.financialReport.documents.consolidated2023ItIfrs"),
            key: "financial_reports/2023/IFSR_consolidated_audited_ITA.pdf",
          },
          {
            name: t("main.financialReport.documents.consolidated2023EnIfrs"),
            key: "financial_reports/2023/IFSR_consolidated_audited_EN.pdf",
          },
          {
            name: t("main.financialReport.documents.halfYear2023En"),
            key: "financial_reports/2023/Rigsave-spa-financial-statement-as-at-30-06-2023.pdf",
          },
          {
            name: t("main.financialReport.documents.halfYear2023It"),
            key: "financial_reports/2023/Bilancio-semestrale-al-30-06-2023.xbrl_.pdf",
          },
          {
            name: t("main.financialReport.documents.separate2023ItGaap"),
            key: "financial_reports/2023/bilancio_separato_rigsavespa_revisionato_31_12_2023.pdf",
          },
        ],
      },
      {
        title: t("main.financialReport.groups.financialReport2022"),
        files: [
          {
            name: t("main.financialReport.documents.consolidated2022En"),
            key: "financial_reports/2022/rigsave-spa-audited-consolidated-fs-2022.pdf",
          },
          {
            name: t("main.financialReport.documents.consolidated2022It"),
            key: "financial_reports/2022/Rigsave_relazione-revisore-bilancio-consolidato-31.12.2022_ITA-version.pdf",
          },
          {
            name: t("main.financialReport.documents.separate2022EnGaap"),
            key: "financial_reports/2022/EN_bilancio-separato-Rigsave-SpA-revisionato-al-31-12-2022_REV_def.pdf",
          },
          {
            name: t("main.financialReport.documents.separate2022ItGaap"),
            key: "financial_reports/2022/bilancio-separato-Rigsave-SpA-revisionato-31-12-2022.pdf",
          },
        ],
      },
      {
        title: t("main.financialReport.groups.financialReport2021"),
        files: [
          {
            name: t("main.financialReport.documents.consolidated2021En"),
            key: "financial_reports/2021/EN_Rigsave_Spa_consolidated_IFRS_compliant_2021.pdf",
          },
          {
            name: t("main.financialReport.documents.consolidated2021It"),
            key: "financial_reports/2021/Rigsave-rel.-di-revisione-e-bil.-cons.-2021_RC134842021BD4450.pdf",
          },
          {
            name: t("main.financialReport.documents.separate2021EnGaap"),
            key: "financial_reports/2021/EN_bilancio-separato-rigsave-spa-revisionato-al-31-12-2021_def.pdf",
          },
          {
            name: t("main.financialReport.documents.separate2021ItGaap"),
            key: "financial_reports/2021/bilancio-separato-rigsave-spa-revisionato-al-31-12-2021.pdf",
          },
        ],
      },
    ],
    [t]
  );

  return (
    <main className="financial-page">
      <section className="financial-hero">
        <div>
          <h1>{t("main.financialReport.title")}</h1>
          <span />
        </div>
      </section>

      <section className="financial-list-section">
        <div className="financial-list">
          {reportGroups.map((group, index) => {
            const firstFile = group.files[0];
            const isOpen = openIndex === index;

            return (
              <div className="financial-row-wrapper" key={group.title}>
                <div className="financial-row">
                  <button
                    type="button"
                    className="financial-open-button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-label={`${t("main.common.open")} ${group.title}`}
                  >
                    <FiPlusCircle />
                  </button>

                  <button
                    type="button"
                    className="financial-name-button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    {group.title}
                  </button>

                  {firstFile && (
                    <a
                      href="/"
                      className="financial-download"
                      aria-label={`${t("main.common.download")} ${
                        group.title
                      }`}
                      onClick={(event) => openS3Document(event, firstFile.key)}
                    >
                      <FiDownload />
                    </a>
                  )}
                </div>

                {isOpen && (
                  <div className="financial-documents">
                    {group.files.map((file) => (
                      <a
                        key={file.key}
                        href="/"
                        onClick={(event) => openS3Document(event, file.key)}
                      >
                        {file.name}
                        <FiDownload />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}

export default FinancialReports;